<template>
  <iq-card data-app>
    <template v-if="update" v-slot:headerTitle>
      <slot name="headerTitle">
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-medkit"></i>
          {{ $t("public.components.organization.visitType.title1") }}
        </h4>
      </slot>
    </template>
    <template v-if="update" v-slot:headerAction>
      <slot name="headerActionMoreBtn"></slot>
      <b-button v-if="
        checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', ['CREATE'])
      " style="right" variant="success" @click="openModal('CREATE')">{{
  $t("public.components.organization.visitType.btnCreate")
}}
      </b-button>
    </template>
    <template v-if="checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', ['LIST'])" v-slot:body>
      <div class="text-right">
        <b-button class="mb-3 mr-1" variant="secondary" @click="getVisitTypesExcel">
          Excel
        </b-button>
      </div>
      <div>
        <v-card-title>
          <v-text-field v-model="searchVisitType" append-icon="mdi-magnify" hide-details single-line @blur="
            $parent.getAllVisitTypes(
              organizationId,
              paginationVisitType.page - 1,
              paginationVisitType.itemsPerPage,
              { name: searchVisitType }
            )
          ">
            <template slot="label">
              <div class="search-datatable">
                <i class="fas fa-search fa-fw"></i>
                {{ $t("public.auth.professional.contact.recipes.search") }}
              </div>
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-arrow-left',
          lastIcon: 'fas fa-arrow-right',
          prevIcon: 'fas fa-minus',
          nextIcon: 'fas fa-plus',
          'items-per-page-options': [10, 25, 50],
        }" :headers="headersVisitTypes" :items="visitTypes" :options.sync="paginationVisitType"
          :server-items-length="total" item-key="id">
          <template v-slot:item.name="{ item }">
            <i :style="'color: ' + item.colour" class="fas fa-circle mr-2"></i>
            {{ item.name }}
          </template>
          <template v-slot:item.priceOffLine="{ item }">
            <div v-if="item.priceOfflineActive">
              {{ item.priceOffline }} {{ item.currency.symbol }}
            </div>
            <div v-else><i class="fas fa-times text-danger"></i></div>
          </template>
          <template v-slot:item.priceOnLine="{ item }">
            <div v-if="item.priceOnlineActive">
              {{ item.priceOnline }} {{ item.currency.symbol }}
            </div>
            <div v-else><i class="fas fa-times text-danger"></i></div>
          </template>
          <template v-slot:item.duration="{ item }">
            {{ item.duration }} {{ $t("generic.minutes") }}
          </template>
          <template v-slot:item.active="{ item }">
            <b-form-checkbox v-if="
              checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                'EDIT',
              ])
            " v-model="item.active" size="lg" switch
              @change="saveActiveStatus(item.id, item.active)"></b-form-checkbox>
            <span v-else>
              <span v-if="item.active">
                {{ $t("public.components.organization.visitType.activated") }}
              </span>
              <span v-else>
                {{ $t("public.components.organization.visitType.unActivated") }}
              </span>
            </span>
          </template>
          <template v-slot:item.ipros="{ item }">
            <b-badge v-if="item.ipros" variant="success">
              {{ $t("generic.yes") }}
            </b-badge>
            <b-badge v-else variant="danger"> {{ $t("generic.no") }}</b-badge>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="div-table-data">
              <button :id="'btnSeeVisitType' + item.id" class="item" v-on:click="openModal('VIEW', item.id)">
                <i class="ri-eye-line"></i>
              </button>
              <b-popover :target="'btnSeeVisitType' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.components.organization.visitType.btnSee")
                }}
                </template>
              </b-popover>
              <button v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'EDIT',
                ])
              " :id="'btnUpdateVisitType' + item.id" class="item" v-on:click="openModal('UPDATE', item.id)">
                <i class="ri-file-info-line"></i>
              </button>
              <b-popover v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'EDIT',
                ])
              " :target="'btnUpdateVisitType' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.components.organization.visitType.btnUpdate")
                }}
                </template>
              </b-popover>
              <button v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'DELETE',
                ])
              " :id="'btnDeleteVisitType' + item.id" class="item" v-on:click="deleteVisitType(item.id)">
                <i class="ri-delete-bin-line"></i>
              </button>
              <b-popover v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'DELETE',
                ])
              " :target="'btnDeleteVisitType' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.components.organization.visitType.deleteVisitType")
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>

        <b-modal id="modal-new-visit" :hide-footer="action === 'VIEW'" centered size="lg" @ok="saveFormStep1">
          <template #modal-title><span v-if="action === 'CREATE'">
              {{
                $t(
                            "public.components.organization.visitType.modalCreate.title.create"
                )
              }}
            </span>
            <span v-if="action === 'VIEW'">
              {{
                $t(
                            "public.components.organization.visitType.modalCreate.title.view"
                )
              }}
            </span>
            <span v-if="action === 'UPDATE'">
              {{
                $t(
                            "public.components.organization.visitType.modalCreate.title.update"
                )
              }}
            </span>
            <span v-if="action !== 'CREATE'">
              <b-badge v-if="active" class="ml-2" variant="success">{{
                $t(
                              "public.components.organization.visitType.modalCreate.badge.active"
                )
              }}</b-badge>
              <b-badge v-else class="ml-2" variant="danger">{{
                $t(
                              "public.components.organization.visitType.modalCreate.badge.noactive"
                )
              }}</b-badge>
            </span>
          </template>
          <template v-if="action === 'CREATE' || action === 'UPDATE'" #modal-ok>
            <div v-if="action === 'CREATE'">
              {{
                $t(
                            "public.components.organization.visitType.modalCreate.btnCreate"
                )
              }}
            </div>
            <div v-if="action === 'UPDATE'">
              {{
                $t(
                            "public.components.organization.visitType.modalCreate.btnUpdate"
                )
              }}
            </div>
          </template>
          <template #modal-cancel>{{
            $t("public.components.organization.visitType.modalCreate.btnCancel")
          }}
          </template>
          <form action="#">
            <b-form-group label-for="visitType">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.typeVisit"
                )
              }}: *
              </template>
              <b-form-input id="visitType" v-model="visitType" :disabled="disabled" v-bind:class="{
                'text-danger': isFormVisitTypeErrors,
                'is-invalid': isFormVisitTypeErrors,
              }" @blur="checkVisitType(visitType)">
              </b-form-input>
              <ul v-if="isFormVisitTypeErrors">
                <li v-for="(error, index) in validatorStep1.getErrors(
                  'visitType'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
            <b-form-group label-for="duration">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.duration"
                )
              }}: *
              </template>
              <b-form-input id="duration" v-model="duration" :disabled="disabled" type="number" v-bind:class="{
                'text-danger': isFormDurationErrors,
                'is-invalid': isFormDurationErrors,
              }" @blur="checkDuration(duration)"></b-form-input>
              <ul v-if="isFormDurationErrors">
                <li v-for="(error, index) in validatorStep1.getErrors('duration')" v-bind:key="index"
                  class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
            <b-form-group label-for="onlineType">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.onlineType"
                )
              }}: *
              </template>
              <b-select id="onlineType" v-model="onlineType" :disabled="disabled" :options="onlineTypeSelect"
                class="form-control" v-bind:class="{
                  'text-danger': isFormOnlineTypeErrors,
                  'is-invalid': isFormOnlineTypeErrors,
                }" @blur="checkOnlineType(onlineType)">
              </b-select>
              <ul v-if="isFormOnlineTypeErrors">
                <li v-for="(error, index) in validatorStep1.getErrors(
                  'onlineType'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>

            <b-form-group label-for="priceSesionOnLine">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.priceOnline"
                )
              }}: *
              </template>
              <b-form-radio-group v-model="priceSesionOnLineBoolean" :disabled="disabled">
                <b-form-radio value="true">{{
                  $t("public.components.organization.visitType.modalCreate.yes")
                }}
                </b-form-radio>
                <b-form-radio value="false">{{
                  $t("public.components.organization.visitType.modalCreate.no")
                }}
                </b-form-radio>
              </b-form-radio-group>
              <b-form-input id="priceSesionOffLine" v-model="priceSesionOnLine"
                :disabled="priceSesionOnLineBoolean == 'false' || disabled" type="number" v-bind:class="{
                  'text-danger': isFormPriceSesionOnLineErrors,
                  'is-invalid': isFormPriceSesionOnLineErrors,
                }" @blur="checkPriceSesionOnLine(priceSesionOnLine)"></b-form-input>
              <ul v-if="isFormPriceSesionOnLineErrors">
                <li v-for="(error, index) in validatorStep1.getErrors(
                  'priceSesionOnLine'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
            <b-form-group label-for="priceSesionOffLine">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.priceOffline"
                )
              }}: *
              </template>
              <b-form-radio-group v-model="priceSesionOffLineBoolean" :disabled="disabled">
                <b-form-radio value="true">{{
                  $t("public.components.organization.visitType.modalCreate.yes")
                }}
                </b-form-radio>
                <b-form-radio value="false">{{
                  $t("public.components.organization.visitType.modalCreate.no")
                }}
                </b-form-radio>
              </b-form-radio-group>
              <b-form-input id="priceSesionOffLine" v-model="priceSesionOffLine"
                :disabled="priceSesionOffLineBoolean == 'false' || disabled" type="number" v-bind:class="{
                  'text-danger': isFormPriceSesionOffLineErrors,
                  'is-invalid': isFormPriceSesionOffLineErrors,
                }" @blur="checkPriceSesionOffLine(priceSesionOffLine)"></b-form-input>
              <ul v-if="isFormPriceSesionOffLineErrors">
                <li v-for="(error, index) in validatorStep1.getErrors(
                  'priceSesionOffLine'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>

            <div v-if="newTaxGet !== undefined">
              <b-form-group label-for="tax">
                <template slot="label">{{
                  $t(
                                  "public.components.organization.visitType.modalCreate.tax"
                  )
                }}: *
                </template>
                <multiselect v-model="tax" :disabled="disabled" :options="taxSelect" :preselect-first="true"
                  :preserve-search="true" label="name" track-by="id" v-bind:deselectGroupLabel="
                    $t(
                      'public.components.organization.visitType.modalCreate.multiselect.tax.deselectGroupLabel'
                    )
                  " v-bind:deselectLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.selectedLabel'
  )
" @blur="checkTax(tax)" @input="resetNewTaxGet">
                  <template slot="singleLabel" slot-scope="props">
                    <div v-if="props.option">
                      <span v-if="props.option.name" class="mr-auto title-typography-color">
                        {{ props.option.name }}
                      </span>
                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <b-list-group-item v-if="props.option" class="d-flex align-items-center">
                      <span v-if="props.option.name" class="mr-auto title-typography-color">
                        {{ props.option.name }}
                      </span>
                    </b-list-group-item>
                  </template>
                </multiselect>
              </b-form-group>
              <b-form-group v-if="newTaxGet && newTaxGet.newTax" label-for="valueTax">
                <template slot="label">{{
                  $t(
                                  "public.components.organization.visitType.modalCreate.nameTax"
                  )
                }}: *
                </template>
                <b-input-group>
                  <b-input id="nameTax" v-model="newTaxGet.name" :disabled="disabled" class="form-control" type="text"
                    v-bind:class="{
                      'text-danger': isFormValueTaxErrors,
                      'is-invalid': isFormValueTaxErrors,
                    }" @blur="checkNameTax(newTaxGet.name)"></b-input>
                </b-input-group>
                <ul v-if="isFormValueTaxErrors">
                  <li v-for="(error, index) in validatorStep1.getErrors(
                    'nameTax'
                  )" v-bind:key="index" class="form-text text-danger">
                    &nbsp;{{ error }}
                  </li>
                </ul>
              </b-form-group>
              <b-form-group v-if="newTaxGet && newTaxGet.newTax" label-for="valueTax">
                <template slot="label">{{
                  $t(
                                  "public.components.organization.visitType.modalCreate.valueTax"
                  )
                }}: *
                </template>
                <b-input-group>

                  <the-mask id="valueTax" v-model="newTaxGet.value" :disabled="disabled" class="form-control" mask="0.##"
                    type="text" v-bind:class="{
                      'text-danger': isFormValueTaxErrors,
                      'is-invalid': isFormValueTaxErrors,
                    }" @blur="checkValueTax(newTaxGet.value)"></the-mask>
                </b-input-group>
                <ul v-if="isFormValueTaxErrors">
                  <li v-for="(error, index) in validatorStep1.getErrors(
                    'valueTax'
                  )" v-bind:key="index" class="form-text text-danger">
                    &nbsp;{{ error }}
                  </li>
                </ul>
              </b-form-group>
            </div>
            <div v-else>
              <b-form-group label-for="tax">
                <template slot="label">{{
                  $t(
                                  "public.components.organization.visitType.modalCreate.tax"
                  )
                }}: *
                </template>
                <multiselect v-model="tax" :disabled="disabled" :options="taxSelect" :preselect-first="true"
                  :preserve-search="true" label="name" track-by="id" v-bind:deselectGroupLabel="
                    $t(
                      'public.components.organization.visitType.modalCreate.multiselect.tax.deselectGroupLabel'
                    )
                  " v-bind:deselectLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.tax.selectedLabel'
  )
" @blur="checkTax(tax)">
                  <template slot="singleLabel" slot-scope="props">
                    <div v-if="props.option">
                      <span v-if="props.option.name" class="mr-auto title-typography-color">
                        {{ props.option.name }}
                      </span>
                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <b-list-group-item v-if="props.option" class="d-flex align-items-center">
                      <span v-if="props.option.name" class="mr-auto title-typography-color">
                        {{ props.option.name }}
                      </span>
                    </b-list-group-item>
                  </template>
                </multiselect>
                <ul v-if="isFormTaxErrors">
                  <li v-for="(error, index) in validatorStep1.getErrors('tax')" v-bind:key="index"
                    class="form-text text-danger">
                    &nbsp;{{ error }}
                  </li>
                </ul>
              </b-form-group>
              <b-form-group v-if="tax && tax.newTax" label-for="valueTax">
                <template slot="label">{{
                  $t(
                                  "public.components.organization.visitType.modalCreate.nameTax"
                  )
                }}: *
                </template>
                <b-input-group>
                  <b-input id="nameTax" v-model="tax.name" :disabled="disabled" class="form-control" type="text"
                    v-bind:class="{
                      'text-danger': isFormValueTaxErrors,
                      'is-invalid': isFormValueTaxErrors,
                    }" @blur="checkNameTax(tax.name)"></b-input>
                </b-input-group>
                <ul v-if="isFormValueTaxErrors">
                  <li v-for="(error, index) in validatorStep1.getErrors(
                    'nameTax'
                  )" v-bind:key="index" class="form-text text-danger">
                    &nbsp;{{ error }}
                  </li>
                </ul>
              </b-form-group>
              <b-form-group v-if="tax && tax.newTax" label-for="valueTax">
                <template slot="label">{{
                  $t(
                                  "public.components.organization.visitType.modalCreate.valueTax"
                  )
                }}: *
                </template>
                <b-input-group>

                  <the-mask id="valueTax" v-model="tax.value" :disabled="disabled" class="form-control" mask="0.##"
                    type="text" v-bind:class="{
                      'text-danger': isFormValueTaxErrors,
                      'is-invalid': isFormValueTaxErrors,
                    }" @blur="checkValueTax(tax.value)"></the-mask>
                </b-input-group>
                <ul v-if="isFormValueTaxErrors">
                  <li v-for="(error, index) in validatorStep1.getErrors(
                    'valueTax'
                  )" v-bind:key="index" class="form-text text-danger">
                    &nbsp;{{ error }}
                  </li>
                </ul>
              </b-form-group>
            </div>
            <b-form-group label-for="currency">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.currency"
                )
              }}: *
              </template>
              <multiselect v-model="currency" :disabled="disabled" :options="currencySelect" :preselect-first="true"
                :preserve-search="true" label="name" track-by="code" v-bind:deselectGroupLabel="
                  $t(
                    'public.components.organization.visitType.modalCreate.multiselect.currency.deselectGroupLabel'
                  )
                " v-bind:deselectLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.currency.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.currency.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.currency.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.currency.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.components.organization.visitType.modalCreate.multiselect.currency.selectedLabel'
  )
">
                <template slot="singleLabel" slot-scope="props">
                  <div v-if="props.option">
                    <span v-if="props.option.name" class="mr-auto title-typography-color">
                      {{ props.option.name }} ({{ props.option.symbol }})
                    </span>
                  </div>
                </template>
                <template slot="option" slot-scope="props">
                  <b-list-group-item v-if="props.option" class="d-flex align-items-center">
                    <span class="mr-auto title-typography-color">
                      {{ props.option.name }} ({{ props.option.symbol }})
                    </span>
                  </b-list-group-item>
                </template>
              </multiselect>
              <ul v-if="isFormCurrencyErrors">
                <li v-for="(error, index) in validatorStep1.getErrors('currency')" v-bind:key="index"
                  class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
            <b-form-group label-cols-xl="6" label-for="colour">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.selectColor"
                )
              }}: *
              </template>
              <b-form-input id="colour" v-model="colour" :disabled="disabled" type="color"></b-form-input>
            </b-form-group>
            <b-form-group label-for="description">
              <template slot="label">{{
                $t(
                              "public.components.organization.visitType.modalCreate.description"
                )
              }}:
              </template>
              <b-form-textarea id="description" v-model="description" :disabled="disabled" size="lg"></b-form-textarea>
            </b-form-group>
            <b-row>
              <b-col cols="3">
                <b-form-group label-for="active">
                  <template slot="label">{{
                    $t(
                                      "public.components.organization.visitType.modalCreate.active"
                    )
                  }}:
                  </template>
                  <b-form-checkbox id="active" v-model="active" :disabled="disabled" size="lg" switch></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-for="ipros">
                  <template slot="label">{{
                    $t(
                                      "public.components.organization.visitType.modalCreate.ipros"
                    )
                  }}:
                  </template>
                  <b-form-checkbox id="ipros" v-model="ipros" :disabled="disabled" size="lg" switch></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </form>
        </b-modal>
      </div>
    </template>
    <notifications group="notificacions" />
  </iq-card>
</template>
<script>
import { xray } from "../../config/pluginInit";

import validator from "vue-m-validator";
import VisitTypeOnlineEnum from "../../json/VisitTypeOnlineEnum";
import { saveAs } from "file-saver";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import currencyService from "../../services/currency";
import organizationService from "../../services/organization";
import utilsService from "../../services/utils";

export default {
  name: "VisitType",
  props: {
    start: false,
    professionalId: "",
    organizationId: "",
    total: 0,
    visitTypes: [],
    update: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "ORGANIZATION",
    },
  },
  watch: {
    paginationVisitType: {
      handler() {
        if (this.start) {
          this.$parent.getAllVisitTypes(this.organizationId, 0, 1000, {
            name: this.searchVisitType,
          });
        }
        this.start = true;
      },
    },
  },
  mounted() {
    xray.index();
    this.getAllCurrencies();
    this.getAllTax();
  },
  computed: {
    isFormCurrencyErrors() {
      let errors = this.validatorStep1.getErrors("currency");
      return errors && errors.length > 0;
    },
    isFormVisitTypeErrors() {
      let errors = this.validatorStep1.getErrors("visitType");
      return errors && errors.length > 0;
    },
    isFormOnlineTypeErrors() {
      let errors = this.validatorStep1.getErrors("onlineType");
      return errors && errors.length > 0;
    },
    isFormDurationErrors() {
      let errors = this.validatorStep1.getErrors("duration");
      return errors && errors.length > 0;
    },
    isFormPriceSesionOnLineErrors() {
      let errors = this.validatorStep1.getErrors("priceSesionOnLine");
      return errors && errors.length > 0;
    },
    isFormPriceSesionOffLineErrors() {
      let errors = this.validatorStep1.getErrors("priceSesionOffLine");
      return errors && errors.length > 0;
    },
    isFormTaxErrors() {
      let errors = this.validatorStep1.getErrors("tax");
      return errors && errors.length > 0;
    },
    isFormValueTaxErrors() {
      let errors = this.validatorStep1.getErrors("valueTax");
      return errors && errors.length > 0;
    },
  },
  methods: {
    resetNewTaxGet() {
      this.newTaxGet = undefined;
    },
    async getAllCurrencies() {
      let self = this;

      currencyService
        .getAllPublic()
        .then((response) => {
          if (response) {
            self.currencySelect = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "currencyService.getAllPublic",
            module: "component-organization-visitType",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        });
    },
    getVisitTypesExcel() {
      let data = { name: this.searchVisitType };

      this.$awn.asyncBlock(
        organizationService.getAllVisitTypesExcel(this.organizationId, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_VISIT_TYPES_EXCEL", info: "" });
            saveAs(response.data, "visitTypes.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllVisitTypesExcel",
            module: "component-organization-visitType",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId, data: data
            }),
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    saveActiveStatus(visitTypeId, active) {
      if (this.type === "PROFESSIONALS") {
        this.saveActiveStatusProfessional(visitTypeId, active);
      }
      if (this.type === "ORGANIZATION") {
        this.saveActiveStatusOrganization(visitTypeId, active);
      }
    },
    saveActiveStatusProfessional(visitTypeId, active) {
      let self = this;
      this.$awn.asyncBlock(
        organizationService.saveActiveStatusVisitTypeProfessional(
          this.organizationId,
          this.professionalId,
          visitTypeId,
          active
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
            self.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.components.organization.visitType.notification.update.title"
              ),
              text: self.$i18n.t(
                "public.components.organization.visitType.notification.update.desc"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.saveActiveStatusVisitTypeProfessional",
            module: "component-organization-visitType",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId,
              professionalId: this.professionalId,
              visitTypeId: visitTypeId,
              active: active
            }),
          });
        },
        " "
      );
    },
    saveActiveStatusOrganization(visitTypeId, active) {
      let self = this;
      this.$awn.asyncBlock(
        organizationService.saveActiveStatusVisitType(
          this.organizationId,
          visitTypeId,
          active
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.visitType.notification.update.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.visitType.notification.update.desc"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.saveActiveStatusVisitType",
            module: "component-organization-visitType",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId,
              visitTypeId: visitTypeId,
              active: active
            }),
          });
        },
        " "
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkCurrency(_currency) {
      const CURRENCY = _currency;
      const RULE_1 = {
        expression: !CURRENCY,
        name: "currency",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erCurrency"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkOnlineType(_onlineType) {
      const ONLINETYPE = _onlineType.trim();
      const RULE_1 = {
        expression: !ONLINETYPE || ONLINETYPE === "",
        name: "onlineType",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erOnlineType"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkVisitType(_visitType) {
      const VISITTYPE = _visitType.trim();
      const RULE_1 = {
        expression: !VISITTYPE || VISITTYPE === "",
        name: "visitType",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erVisitType"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkDuration(_duration) {
      const DURATION = _duration;
      const RULE_1 = {
        expression: (!DURATION || DURATION === "") && DURATION !== 0,
        name: "duration",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erDuration"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp("^[0-9]+$");
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(DURATION),
        name: "duration",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erDuration2"
        ),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkPriceSesionOnLine(_priceSesionOnLine) {
      const PRICEONLINE = _priceSesionOnLine;
      const RULE_1 = {
        expression: (!PRICEONLINE || PRICEONLINE === "") && PRICEONLINE !== 0,
        name: "priceSesionOnLine",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erPrice"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp("^[0-9]+$");
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PRICEONLINE),
        name: "priceSesionOnLine",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erPrice2"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPriceSesionOffLine(_priceSesionOffLine) {
      const PRICEOFFLINE = _priceSesionOffLine;
      const RULE_1 = {
        expression:
          (!PRICEOFFLINE || PRICEOFFLINE === "") && PRICEOFFLINE !== 0,
        name: "priceSesionOffLine",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erPrice"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(/^(([1-9]*)|(([1-9]*).([0-9]*)))$/);
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PRICEOFFLINE),
        name: "priceSesionOffLine",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erPrice2"
        ),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkTax(_tax) {
      const TAX = _tax;
      const RULE_1 = {
        expression: TAX === undefined || TAX === null || TAX === "",
        name: "tax",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erTax"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkValueTax(_valuetax) {
      const VALUETAX = _valuetax;
      const RULE_1 = {
        expression: !VALUETAX || VALUETAX === "",
        name: "valueTax",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erValueTax"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkNameTax(_nametax) {
      const NAMETAX = _nametax;
      const RULE_1 = {
        expression: !NAMETAX || NAMETAX === "",
        name: "valueTax",
        msg: this.$i18n.t(
          "public.components.organization.visitType.errors.erNameTax"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    saveFormStep1(evt) {
      evt.preventDefault();

      if (this.action === "CREATE") {
        this.checkFormStep1();
        if (this.validatorStep1.errors.length === 0) {
          this.createVisitType(this.organizationId);
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.visitType.errors.erTitle"
            ),
            text: this.$i18n.t(
              "public.components.organization.visitType.errors.erStep1"
            ),
            type: "error",
          });
        }
      }
      if (this.action === "UPDATE") {
        this.checkFormStep1();
        if (this.validatorStep1.errors.length === 0) {
          this.updateVisitType();
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.visitType.errors.erTitle"
            ),
            text: this.$i18n.t(
              "public.components.organization.visitType.errors.erStep1"
            ),
            type: "error",
          });
        }
      }
    },
    openModal(action, visitTypeId) {
      this.action = action;
      if (action === "CREATE") {
        this.clearForm();
        this.disabled = false;
        this.$bvModal.show("modal-new-visit");
      }
      if (action === "UPDATE") {
        this.clearForm();
        this.disabled = false;
        this.getVisitType(visitTypeId);
      }
      if (action === "VIEW") {
        this.clearForm();
        this.disabled = true;
        this.getVisitType(visitTypeId);
      }
    },
    clearForm() {
      this.getAllTax();
      this.newTaxGet = undefined;
      this.validatorStep1.errors = [];
      this.visitType = "";
      this.description = "";
      this.duration = 45;
      this.priceSesionOnLine = 0;
      this.priceSesionOffLine = 0;
      this.priceSesionOnLineBoolean = "false";
      this.priceSesionOffLineBoolean = "false";
      this.colour = "#000000";
      this.disabled = false;
      this.active = true;
      this.ipros = true;
      this.tax = {};
      this.onlineType = "MONOCOFERENCE";
      this.currency = {};
    },
    checkFormStep1() {
      this.checkCurrency(this.currency);
      this.checkVisitType(this.visitType);
      this.checkDuration(this.duration);
      if (this.priceSesionOnLineBoolean) {
        this.checkPriceSesionOnLine(this.priceSesionOnLine);
      }
      if (this.priceSesionOffLineBoolean) {
        this.checkPriceSesionOffLine(this.priceSesionOffLine);
      }

      this.checkOnlineType(this.onlineType);
      //   this.checkTax(this.tax);

      // this.checkValueTax(this.tax.value);
    },
    createVisitType(organizationId) {
      let self = this;

      var data = {
        name: this.visitType,
        description: this.description,
        duration: this.duration,
        priceOnline: this.priceSesionOnLine,
        priceOffline: this.priceSesionOffLine,
        priceOnlineActive: this.priceSesionOnLineBoolean,
        priceOfflineActive: this.priceSesionOffLineBoolean,
        colour: this.colour,
        onlineType: this.onlineType,
        active: this.active,
        ipros: this.ipros,
        currency: this.currency,
        newTax: this.tax.newTax,
      };

      data.tax = {
        id: this.tax.id,
        name: this.tax.name,
        organizationId: this.tax.organization.id,
        value: this.tax.value,
      };

      if(data.tax.value){
        data.tax.value = data.tax.value / 100;
      }

      if (this.type === "ORGANIZATION") {
        this.$awn.asyncBlock(
          organizationService.createVisitType(organizationId, data),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
              //Close modal
              this.$bvModal.hide("modal-new-visit");

              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.components.organization.visitType.notification.title"
                ),
                text: this.$i18n.t(
                  "public.components.organization.visitType.notification.desc"
                ),
                type: "success",
              });

              self.$parent.getAllVisitTypes(
                organizationId,
                this.paginationVisitType.page - 1,
                this.paginationVisitType.itemsPerPage,
                { name: this.searchVisitType }
              );

              //:TODO tiene que actualizar el datatable
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.createVisitType",
              module: "component-organization-visitType",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: organizationId, data: data
              }),
            });
          },
          " "
        );
      }
      if (this.type === "PROFESSIONALS") {
        this.$awn.asyncBlock(
          organizationService.createVisitTypeProfessional(
            organizationId,
            self.professionalId,
            data
          ),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
              //Close modal
              this.$bvModal.hide("modal-new-visit");

              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.components.organization.visitType.notification.title"
                ),
                text: this.$i18n.t(
                  "public.components.organization.visitType.notification.desc"
                ),
                type: "success",
              });

              //:TODO tiene que actualizar el datatable
              self.$parent.getAllVisitTypes(
                self.professionalId,
                self.paginationVisitType.page - 1,
                self.paginationVisitType.itemsPerPage,
                { name: this.searchVisitType }
              );
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.createVisitTypeProfessional",
              module: "component-organization-visitType",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: organizationId,
                professionalId: self.professionalId,
                data: data
              }),
            });
          },
          " "
        );
      }
    },
    //Update
    getVisitType(visitTypeId) {
      let self = this;

      if (this.type === "ORGANIZATION") {
        this.$awn.asyncBlock(
          organizationService.getVisitType(this.organizationId, visitTypeId),
          (response) => {
            self.getPostPetition(response);
            self.$bvModal.show("modal-new-visit");
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.getVisitType",
              module: "component-organization-visitType",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: organizationId, visitTypeId: visitTypeId
              }),
            });
          },
          " "
        );
      }
      if (this.type === "PROFESSIONALS") {
        this.$awn.asyncBlock(
          organizationService.getVisitTypeProfessional(
            this.organizationId,
            this.professionalId,
            visitTypeId
          ),
          (response) => {
            self.getPostPetition(response);
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.getVisitTypeProfessional",
              module: "component-organization-visitType",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: organizationId, professionalId: professionalId
              }),
            });
          },
          " "
        );
      }
    },
    deleteVisitType(visitTypeId) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.deleteVisitType(this.organizationId, visitTypeId),
        (response) => {
          utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.visitType.notification.title"
            ),
            text: this.$i18n.t(
              "public.components.organization.visitType.notification.deleteSuccess"
            ),
            type: "success",
          });
          self.$parent.getAllVisitTypes(
            self.organizationId,
            self.paginationVisitType.page - 1,
            self.paginationVisitType.itemsPerPage,
            { name: this.searchVisitType }
          );
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.deleteVisitType",
            module: "component-organization-visitType",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId, visitTypeId: visitTypeId
            }),
          });
        },
        " "
      );
    },
    getPostPetition(response) {
      let self = this;
      if (response) {
        self.visitTypeId = response.data.id;
        self.visitType = response.data.name;
        self.description = response.data.description;
        self.duration = response.data.duration;

        self.priceSesionOnLine = response.data.priceOnline;
        self.priceSesionOffLine = response.data.priceOffline;
        if (
          response.data.priceOnlineActive === true ||
          response.data.priceOnlineActive === false
        ) {
          self.priceSesionOnLineBoolean =
            response.data.priceOnlineActive.toString();
        }
        if (
          response.data.priceOfflineActive === true ||
          response.data.priceOfflineActive === false
        ) {
          self.priceSesionOffLineBoolean =
            response.data.priceOfflineActive.toString();
        }
        self.colour = response.data.colour;
        self.active =
          response.data.active === null ? false : response.data.active;
        self.ipros = response.data.ipros === null ? false : response.data.ipros;
        self.onlineType = response.data.onlineType;
        self.currency = this.currencySelect.find(
          (option) => option.id === response.data.currency.id
        );
        self.tax = this.taxSelect.find(
          (option) => option.id === response.data.tax.id
        );

        if (self.tax === undefined) {
          self.newTaxGet = {
            defaultItem: response.data.tax.defaultItem,
            id: response.data.tax.id,
            name: response.data.tax.name,
            nameI18n: response.data.tax.nameI18n,
            newTax: response.data.tax.newTax,
            organization: response.data.tax.organization,
            value: response.data.tax.value,
          };

          self.taxSelect.push(self.newTaxGet);

          self.tax = this.taxSelect.find(
            (option) => option.id === response.data.tax.id
          );
        }
      }
    },
    updateVisitType() {
      let self = this;

      var data = {
        id: this.visitTypeId,
        name: this.visitType,
        description: this.description,
        duration: this.duration,
        priceOnline: this.priceSesionOnLine,
        priceOffline: this.priceSesionOffLine,
        priceOnlineActive: this.priceSesionOnLineBoolean,
        priceOfflineActive: this.priceSesionOffLineBoolean,
        colour: this.colour,
        onlineType: this.onlineType,
        active: this.active,
        ipros: this.ipros,
        currency: this.currency,
        newTax: this.tax.newTax,
      };
      if (this.newTaxGet === undefined) {
        data.tax = {
          id: this.tax.id,
          name: this.tax.name,
          organizationId: this.tax.organization.id,
          value: this.tax.value,
        };
      } else {
        data.tax = {
          id: this.newTaxGet.id,
          name: this.newTaxGet.name,
          organizationId: localStorage.getItem("organizationId"),
          value: this.newTaxGet.value,
        };
      }

      //set 0-100 scale to tax value
      if(data.tax.value){
        data.tax.value = data.tax.value / 100;
      }

      if (this.type === "ORGANIZATION") {
        this.$awn.asyncBlock(
          organizationService.updateVisitType(
            self.organizationId,
            self.visitTypeId,
            data
          ),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
              //Close modal
              this.$bvModal.hide("modal-new-visit");

              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.components.organization.visitType.notification.update.title"
                ),
                text: this.$i18n.t(
                  "public.components.organization.visitType.notification.update.desc"
                ),
                type: "success",
              });

              self.$parent.getAllVisitTypes(
                self.organizationId,
                self.paginationVisitType.page - 1,
                self.paginationVisitType.itemsPerPage,
                { name: this.searchVisitType }
              );
              //:TODO tiene que actualizar el datatable
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.updateVisitType",
              module: "component-organization-visitType",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: self.organizationId,
                visitTypeId: self.visitTypeId,
                data: data
              }),
            });
          },
          " "
        );
      }
      if (this.type === "PROFESSIONALS") {
        this.$awn.asyncBlock(
          organizationService.updateVisitTypeProfessional(
            self.organizationId,
            self.professionalId,
            self.visitTypeId,
            data
          ),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
              //Close modal
              this.$bvModal.hide("modal-new-visit");

              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.components.organization.visitType.notification.update.title"
                ),
                text: this.$i18n.t(
                  "public.components.organization.visitType.notification.update.desc"
                ),
                type: "success",
              });

              self.$parent.getAllVisitTypes(
                self.organizationId,
                self.paginationVisitType.page - 1,
                self.paginationVisitType.itemsPerPage,
                { name: this.searchVisitType }
              );
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.updateVisitTypeProfessional",
              module: "component-organization-visitType",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: self.organizationId,
                professionalId: self.professionalId,
                visitTypeId: self.visitTypeId,
                data: data
              }),
            });
          },
          " "
        );
      }
    },
    //Tax
    async getAllTax() {
      let self = this;

      organizationService
        .getAllTaxes(this.organizationId)
        .then((response) => {
          if (response) {
            self.taxSelect = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllTaxes",
            module: "component-organization-visitType",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: self.organizationId
            }),
          });
        });
    },
  },
  data() {
    return {
      paginationVisitType: { page: 1, itemsPerPage: 10 },
      action: "",
      disabled: false,
      isValidateStep1: false,
      validatorStep1: validator,
      //Campos
      onlineType: "MONOCOFERENCE",
      visitTypeId: "",
      visitType: "",
      description: "",
      duration: 45,
      priceSesionOnLine: 0,
      priceSesionOnLineBoolean: "false",
      priceSesionOffLine: 0,
      priceSesionOffLineBoolean: "false",
      active: true,
      ipros: true,
      colour: "",
      tax: {},
      newTaxGet: undefined,
      currency: {},
      currencySelect: [],
      //Tablas
      searchVisitType: "",

      headersVisitTypes: [
        {
          text: this.$i18n.t(
            "public.components.organization.visitType.headers.visitType"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.visitType.headers.duration"
          ),
          value: "duration",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.visitType.headers.priceOnline"
          ),
          value: "priceOnLine",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.visitType.headers.priceOffline"
          ),
          value: "priceOffLine",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.visitType.headers.active"
          ),
          value: "active",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.visitType.headers.ipros"
          ),
          value: "ipros",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      visitType: [],
      //Selects
      onlineTypeSelect: VisitTypeOnlineEnum,
      taxSelect: [],
    };
  },
  components: { Multiselect },
};
</script>
